import axios from 'axios'

export default{
    async BeforeSend(data){
        const response = await axios.get(`/api/agreement/get/beforesent/${data}`)
        return response
    },
    async AfterSend(data){
        const response = await axios.get(`/api/agreement/get/aftersent/${data}`)
        return response
    },
    async Create(data,expire){
        const response = await axios.post(`/api/agreement/create/${data}/${expire}`)
        return response
    },
    async Table(data){
        const response = await axios.post(`/api/agreement/table`,data)
        return response
    },
    async Detail(data){  
        const response = await axios.get(`/api/agreement/get/detail/${data}`)
        return response
    }
}